module.exports = "pegasus/assets/theme4/twitter-icon.png";